import React, { useContext, useState, useEffect, useRef } from 'react'

import SectionThemeContext from '@contexts/SectionTheme'

import { Button, InnerContent } from '@/atoms'
import { Container, Row, Col } from '@/atoms/Grid'
import { ItemsGrouped } from '@/organisms'

import * as S from './styles'
import Image from 'next/image'
import IngegnoDot from '@/molecules/IngegnoDot'

const Ingegno = ({
  tagline,
  title,
  paragraph,
  ctaPrimary,
  ctaSecondary,
  align,
  space = 'lg',
  embedded = 0,
  items,
}) => {
  const colorScheme = useContext(SectionThemeContext)
  const [activeTooltipId, setActiveTooltipId] = useState(null)
  const [animationsEnabled, setAnimationsEnabled] = useState(true)

  const toggleAnimations = () => {
    const newValue = !animationsEnabled
    console.log('Animations enabled:', newValue)
    setAnimationsEnabled(newValue)
  }
  const ingegnoRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        event.target.closest('.tooltip-container') ||
        event.target.closest('.dot-container')
      ) {
        return
      }
      setActiveTooltipId(null)
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  return (
    <S.Ingegno
      align={align}
      colorScheme={colorScheme}
      space={space}
      ref={ingegnoRef}
    >
      <Container noGutter={embedded}>
        <S.IngegnoWrapper>
          {tagline?.content ? (
            <InnerContent
              as={tagline.as}
              typo={tagline.typo}
              content={tagline.content}
              uppercase
              bold
              isTagline={true}
            />
          ) : null}
          {title?.content ? (
            <S.IngegnoTitle>
              <InnerContent
                as={title.as}
                typo={title.typo}
                content={title.content}
                bold
              />
            </S.IngegnoTitle>
          ) : null}
          {paragraph?.content ? (
            <S.IngegnoParagraph>
              <InnerContent
                as={paragraph.as}
                typo={paragraph.typo}
                content={paragraph.content}
              />
            </S.IngegnoParagraph>
          ) : null}
          {items && items.length > 0 && (
            <>
              <Row
                justify='flex-end'
                style={{marginTop: '32px'}}
              >
                <Button
                  tertiary
                  handleClick={toggleAnimations}
                  iconStart={animationsEnabled ? 'pause' : 'play'}
                >
                  {animationsEnabled
                    ? 'Disattiva animazioni'
                    : 'Attiva animazioni'}
                </Button>
              </Row>
              <S.IngegnoImage>
                <Image
                  src={`/assets/ingegno-brain.png`}
                  alt={'Scopri Ingegno'}
                  fill
                  sizes='(max-width: 768px) 50vw, (max-width: 1200px) 50vw, 33vw'
                />
                {items.map((item, index) => (
                  <IngegnoDot
                    key={`ingegno-dot-${index}`}
                    id={`ingegno-dot-${index}`}
                    x={item.position?.x || 50}
                    y={item.position?.y || 50}
                    data={{
                      title: item.title || '',
                      content: item.description || '',
                      icon: item.icon || '',
                      ctas: item.ctas || [],
                    }}
                    isActive={activeTooltipId === `ingegno-dot-${index}`}
                    setActiveTooltipId={setActiveTooltipId}
                    animationsEnabled={animationsEnabled}
                  />
                ))}
              </S.IngegnoImage>
            </>
          )}
          {ctaPrimary || ctaSecondary ? (
            <S.IngegnoButtons>
              <ItemsGrouped
                direction={{ xs: 'column', md: 'row' }}
                space={{ xs: 16, md: 16 }}
              >
                {ctaPrimary ? (
                  <Button
                    {...ctaPrimary}
                    primary
                  />
                ) : null}
                {ctaSecondary ? (
                  <Button
                    {...ctaSecondary}
                    secondary
                  />
                ) : null}
              </ItemsGrouped>
            </S.IngegnoButtons>
          ) : null}
        </S.IngegnoWrapper>
      </Container>
    </S.Ingegno>
  )
}

export default Ingegno
